/* eslint-disable camelcase */
import proj4 from "proj4";
import * as All_EPSG from "epsg-index/all.json";
import { makeid } from "../../../common/utils";
import { ControlPointItem, ControlPointsImportData } from "../../../types/interfaces";
import { createMeasure } from "./utilsValidationGeo";
import { DataStore } from "../../../store/DataStore";

export const importFileData = (content: string, fields: string[], values: ControlPointsImportData) => {
    const all_EPSG = JSON.parse(JSON.stringify(All_EPSG));
    const epsgData = all_EPSG[values.epsg];
    const fromProjection = epsgData.proj4;

    const toProjection = window.activeProj4String || "EPSG:4326";

    const lines = content.split("\n");

    const data: ControlPointItem[] = [];

    if (lines.length > 0) {
        let titleFieldIndex = -1;
        let xFieldIndex = -1;
        let yFieldIndex = -1;
        let zFieldIndex = -1;

        const allProjectData = DataStore.allProjectData;

        const item = allProjectData.find((p) => p.id === values.projectId);

        let count = 0;
        if (item) {
            count = item.data.length;
        }

        try {
            lines.forEach((line, index) => {
                if (!line.trim()) return;
                const items = line.trim().split(",");
                if (index === 0) {
                    if (values.title) titleFieldIndex = fields.indexOf(values.title);
                    xFieldIndex = fields.indexOf(values.x);
                    yFieldIndex = fields.indexOf(values.y);
                    zFieldIndex = fields.indexOf(values.z);

                    if (values.hasHeader) {
                        return;
                    }
                }

                let title = "";
                if (titleFieldIndex > -1) {
                    title = items[titleFieldIndex];
                } else {
                    title = (count + index + 1).toString();
                }

                const noValue = makeid(5);

                const coordinates = proj4(fromProjection, toProjection, [
                    parseFloat(items[yFieldIndex]),
                    parseFloat(items[xFieldIndex]),
                    parseFloat(items[zFieldIndex])
                ]);

                const pointItem = {
                    no: noValue,
                    title: title,
                    x: coordinates[1],
                    y: coordinates[0],
                    z: coordinates[2],
                    show: true
                };

                data.push(pointItem);

                createMeasure(pointItem);
            });
        } catch (e) {
            console.error(e);
            return null;
        }
    }

    return data;
};

export const deleteControlPointItemData = (projectId: string, pointId: string) => {
    const allProjectData = DataStore.allProjectData;
    const item = allProjectData.find((p) => p.id === projectId);
    if (item) {
        item.data = item.data.filter((p) => p.no !== pointId);

        return JSON.parse(JSON.stringify(item.data));
    }

    return undefined;
};

export const updateControlPointItemData = (
    projectId: string,
    pointId: string,
    updateData: { [key: string]: string | number | boolean }
) => {
    const allProjectData = DataStore.allProjectData;
    const item = allProjectData.find((p) => p.id === projectId);
    if (item) {
        const pointsData = item.data;
        const index = pointsData.findIndex((p) => p.no === pointId);
        if (index > -1) {
            const pointData = pointsData[index];
            pointsData[index] = { ...pointData, ...updateData };
        }

        return JSON.parse(JSON.stringify(pointsData));
    }

    return undefined;
};
